import { DataGrid, Dialog } from '@ijoin/components';
import { useGetAdminIraCompanionPlans } from '@ijoin/hooks';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography
} from '@mui/material';

import { ChangeEvent, FC, useState } from 'react';

export const IraCompanionPlansDialog: FC<{
  iraCompanionId: number;
  onClose: () => void;
}> = props => {
  const [search, setSearch] = useState('');

  const plans = useGetAdminIraCompanionPlans(props.iraCompanionId);

  const onSearchChange = (event: ChangeEvent<HTMLInputElement>) =>
    setSearch(event.target.value);

  return (
    <Dialog
      data-testid='iraCompanionPlansDialog'
      fullWidth
      isOpen
      maxWidth='sm'
      onClose={props.onClose}>
      <DialogTitle variant='h3'>Plan Associations</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography color='text.secondary'>
            Count: {plans.data?.length ?? 0}
          </Typography>
          <TextField
            data-testid='searchIraCompanionPlans'
            fullWidth
            onChange={onSearchChange}
            placeholder='Search plans...'
            size='small'
            value={search}
          />
          <DataGrid
            columns={[{ field: 'planName', flex: 1, headerName: 'Plan' }]}
            disableColumnMenu
            disableRowSelectionOnClick
            getRowId={row => row.planId}
            initialSort={[{ field: 'planName', sort: 'asc' }]}
            loading={plans.isFetching}
            rows={(plans.data ?? []).filter(plan =>
              plan.planName.toLowerCase().includes(search.toLowerCase())
            )}
            slotProps={{
              noRowsOverlay: { message: 'No plan associations' },
              root: {
                'data-component': 'dataGrid',
                'data-testid': 'iraCompanionPlans'
              }
            }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          data-testid='closeIraCompanionPlans'
          onClick={props.onClose}
          variant='contained'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

IraCompanionPlansDialog.displayName = 'IraCompanionPlansDialog';
